export default "__VITE_ASSET__bad5b312__"